var map = {
	"./icons/React-icon.png": 44,
	"./icons/git-icon.png": 855,
	"./icons/javascript-icon.png": 1544,
	"./icons/logo.png": 6928,
	"./icons/node-icon.png": 3315,
	"./icons/php-icon.png": 8947,
	"./icons/python-icon.jpg": 6057,
	"./icons/python-icon.png": 321,
	"./icons/sql-icon.png": 3651,
	"./icons/ts-icon.png": 4874,
	"./icons/wordpress-icon.png": 3924,
	"./portrait.jpg": 4377,
	"./portrait_2.jpg": 4126,
	"./portrait_3.jpg": 8907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7909;